import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Formik } from 'formik'
import * as Yup from 'yup'
import cx from 'classnames'
import { validations } from 'common/validations'
import { routes } from 'config/routes'

import InputButton from 'components/InputButton/InputButton'
import TextField from 'components/TextField/TextField'

import 'components/SignInForm/SignInForm.scss'

type IValues = {
  emailOrPhone: string,
}

const defaultFormInitialValues: IValues = {
  emailOrPhone: '',
}

const SignInForm = props => {
  const {
    state: { isSignInLoading },
    onSubmit,
  } = props

  return (
    <Fragment>
      <div className="form-card">
        <div className="title">Manage Account</div>
        <Formik
          initialValues={{
            ...defaultFormInitialValues,
          }}
          onSubmit={onSubmit}
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={Yup.object().shape({
            emailOrPhone: validations.emailOrPhone,
          })}
        >
          {props => {
            const {
              values,
              errors,
              handleBlur,
              handleSubmit,
              handleChange,
              setFieldValue,
            } = props

            return (
              <form onSubmit={handleSubmit}>
                <div className="SignInPage__InputType_row AuthLayout__Input_row">
                  <TextField
                    type="text"
                    name="emailOrPhone"
                    placeholder="Email or Phone"
                    variant="dark"
                    onChange={handleChange}
                    value={values.emailOrPhone}
                    onBlur={e => {
                      const value = e.target.value.toLowerCase().trim()
                      setFieldValue('emailOrPhone', value)
                      handleBlur(e)
                    }}
                    autoFocus={true}
                    validationFailed={errors.emailOrPhone}
                  />
                </div>
                <div
                  className={cx('action-btn', {
                    'action-btn--disabled': !values.emailOrPhone,
                  })}
                >
                  <InputButton type="submit" isLoading={isSignInLoading}>
                    Manage Account
                  </InputButton>
                </div>
              </form>
            )
          }}
        </Formik>
        <div className="terms">
          By continuing, you agree to our{' '}
          <Link
            to={routes.termsOfService.path}
            title="Terms and Conditions"
            target="_blank"
          >
            Terms and Conditions
          </Link>{' '}
          and{' '}
          <Link
            to={routes.privacyAndPolicy.path}
            title="Privacy Policy"
            target="_blank"
          >
            Privacy Policy
          </Link>
          .
        </div>
      </div>
      <div className="SignInPage__text">
        <Link to={routes.signup.path} title="Not on Yac yet? Set up your team">
          Not on Yac yet? Set up your team
        </Link>
      </div>
    </Fragment>
  )
}

SignInForm.defaultProps = {
  state: {
    isSignInLoading: false,
  },
  onSubmit: () => {},
}
export default SignInForm
